<template>
  <div class="row justify-content-center g-3 g-md-4 start-choices-row">
    <div
      v-for="choice in createChoices"
      :key="choice.path"
      class="col-md-6"
    >
      <div
        class="start-choice-card"
        role="button"
        tabindex="0"
        :aria-label="t(choice.titleKey)"
        @click="$emit('choose', choice.path)"
        @keydown.enter.prevent="$emit('choose', choice.path)"
        @keydown.space.prevent="$emit('choose', choice.path)"
      >
        <div class="start-choice-icon" aria-hidden="true">
          <i :class="choice.icon"></i>
        </div>
        <p class="start-choice-title">{{ t(choice.titleKey) }}</p>
        <p class="start-choice-subtitle mb-0">{{ t(choice.subtitleKey) }}</p>
        <span class="start-choice-arrow" aria-hidden="true">
          <i class="fa-solid fa-arrow-left" v-if="isHebrew"></i>
          <i class="fa-solid fa-arrow-right" v-else></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { translationMixin } from "@/mixins/translationMixin";

// The two equal ways to create a ride: from a document, or manually.
// Shown on the Start page and in the "create a ride" popup on /user_rides.
// Emits `choose` with the chosen page's path; the parent decides how to go there.
export default {
  name: "CreateRideChoices",
  mixins: [translationMixin],
  data() {
    return {
      createChoices: [
        {
          path: "/import-ride-documents",
          icon: "fa-solid fa-file-arrow-up",
          titleKey: "startInsertRideFromDocumentTitle",
          subtitleKey: "startInsertRideFromDocumentSubtitle",
        },
        {
          path: "/ride_information",
          icon: "fa-solid fa-pen-to-square",
          titleKey: "startInsertRideManualTitle",
          subtitleKey: "startInsertRideManualSubtitle",
        },
      ],
    };
  },
};
</script>

<style scoped>
.start-choice-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.75rem 2rem 2rem;
  background: white;
  border: 2px solid rgba(7, 160, 195, 0.18);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(7, 160, 195, 0.1);
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.start-choice-card:hover {
  transform: translateY(-6px);
  border-color: #07a0c3;
  box-shadow: 0 16px 40px rgba(7, 160, 195, 0.22);
}

.start-choice-arrow {
  margin-top: auto;
  padding-top: 1.5rem;
  color: #07a0c3;
  font-size: 1.6rem;
  transition: transform 0.2s ease;
}

.start-choice-card:hover .start-choice-arrow {
  transform: translateX(6px);
}

[dir="rtl"] .start-choice-card:hover .start-choice-arrow {
  transform: translateX(-6px);
}

.start-choice-card:focus {
  outline: 2px solid #07a0c3;
  outline-offset: 2px;
}

.start-choice-icon {
  width: 76px;
  height: 76px;
  box-shadow: 0 8px 20px rgba(7, 160, 195, 0.3);
  margin: 0 auto 1rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  color: white;
  font-size: 2.8rem;
}

.start-choice-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e1e1e;
  margin-bottom: 0.5rem;
}

.start-choice-subtitle {
  font-size: 1.4rem;
  color: #4a4a4a;
}

@media (max-width: 767.98px) {
  .start-choices-row > [class*="col-"] {
    margin-bottom: 1.5rem;
  }
}
</style>
